export default function flashBanner() {
  return {
    init() {
      setTimeout(() => {
        this.show = true;
        setTimeout(() => {
          this.show = false;
        }, 3500);
      }, 1);
    },
    show: false,
  };
};
